module.exports = __webpack_public_path__ + "static/media/img3-2.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/biosense/biomasa/img3-2.png
// module id = 2287
// module chunks = 3